import React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import PageNotFound from '../PageNotFound'

export default function InfluencerDashboardRoutes() {

  const { code } = useParams()
  console.log(code)

  return (
    <div>
      InfluencerDashboardRoutes

      <Routes>
        <Route path="/" element={<p>Code</p>}/>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  )
}